import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/.pnpm/nextjs-toploader@3.9.17_next@15.5.9_react-dom@19.2.3_react@19.2.3__react@19.2.3__react-_32f81a65fc541314e13892f76e5fc884/node_modules/nextjs-toploader/dist/index.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.9_react-dom@19.2.3_react@19.2.3__react@19.2.3/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--font-inter\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/app/src/shared/components/feedback/error-boundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TranslationGuard"] */ "/app/src/shared/components/feedback/translation-guard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/app/src/shared/components/providers/theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ColorThemeProvider"] */ "/app/src/shared/store/color-theme-provider.tsx");
